export { default } from "./ChallengeTokensInfoText";
